import { Dialog } from "@/components/ui/Dialog";
import { Button } from "@/components/ui/Button";
import { PROJECT_OVERVIEW_NESTED_OVERLAY_Z } from "@/projectOverview/projectOverviewLayers";

export function StuecklistePublicViewDialog({
  open,
  url,
  title = "Digitale Ansicht",
  onClose,
}: {
  open: boolean;
  url: string | null;
  title?: string;
  onClose: () => void;
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      size="xl"
      fullScreenMobile
      plainBackdrop
      zIndexClass={PROJECT_OVERVIEW_NESTED_OVERLAY_Z}
      bodyClassName="!p-0 overflow-hidden flex flex-col"
      footer={
        <div className="flex w-full flex-wrap items-center justify-between gap-2">
          {url ? (
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-accent hover:underline"
            >
              In neuem Tab öffnen
            </a>
          ) : (
            <span />
          )}
          <Button type="button" variant="secondary" onClick={onClose}>
            Schließen
          </Button>
        </div>
      }
    >
      {url ? (
        <iframe
          title={title}
          src={url}
          className="h-[min(75vh,720px)] w-full flex-1 border-0 bg-[#0f1418] max-sm:h-full"
        />
      ) : null}
    </Dialog>
  );
}
